// @ts-expect-error: @rails/request.js is not typed
import { FetchRequest } from '@rails/request.js'
import { useMutation } from '@tanstack/react-query'

import { GrapeAPIError, type GrapeAPIErrorType } from './GrapeAPIError'

type FinchConnectSession = {
  session_id: string;
}

export function useCreateFinchConnectSession () {
  return useMutation<FinchConnectSession, GrapeAPIErrorType, { payrollProviderConfigId: string }>({
    mutationFn: async ({ payrollProviderConfigId }: { payrollProviderConfigId: string }) => {
      const request = new FetchRequest(
        'post',
        '/api/web/payroll/finch/create_connect_session',
        {
          body: { payroll_provider_config_id: payrollProviderConfigId },
        }
      )
      const response = await request.perform()
      if (!response.ok) {
        const errors = await response.json
        throw GrapeAPIError({
          status: response.status,
          message: errors.message,
          errors: errors.errors,
        })
      }
      return response.json
    },
  })
}
